export enum LANGUAGES {
  ENGLISH = 'en',
  FRENCH = 'fr',
  GERMAN = 'de',
  SPANISH = 'es',
  JAPANESE = 'ja',
}

export const SUPPORTED_LANGUAGES: LANGUAGES[] = [
  LANGUAGES.ENGLISH,
  LANGUAGES.SPANISH,
  LANGUAGES.FRENCH,
  LANGUAGES.GERMAN,
  LANGUAGES.JAPANESE,
]

export const LANGUAGE_LOCALES = {
  en: 'English',
  fr: 'French',
  de: 'German',
  es: 'Spanish',
  ja: 'Japanese',
}
